<template>
    <div class="main-content-container container-fluid px-4">
        <!-- Page Header -->
        <div class="page-header row no-gutters py-4">
            <div class="col-12 flex-header text-center text-sm-left mb-0">
                <h3 class="page-title">Spółki</h3>
                <d-button
                    theme="success"
                    @click="$router.push({name: 'company-new'})">
                    <i class="material-icons">add</i> Nowa spółka
                </d-button>
            </div>
        </div>

        <!-- Default Light Table -->
        <template v-if="loadError">
            <d-alert
                show
                theme="warning">
                Wczytywanie danych nie powiodło się.
                <a
                    href="javascript:window.location.reload();"
                    class="alert-link">
                    Odśwież stronę
                </a>
                aby spróbować ponownie.
            </d-alert>
        </template>
        <template v-else>
            <transition name="fade">
                <d-card class="card-small">
                    <div
                        v-if="!loaded"
                        class="overlay-loading">
                        <h2 class="preloader isLoading">Trwa ładowanie</h2>
                    </div>
                    <d-card-header class="border-bottom flex-header">
                        <h6 class="m-0">Lista spółek</h6>
                    </d-card-header>
                    <d-card-body class="p-0 pb-2 text-center">
                        <table class="table mb-0 responsive-table">
                            <thead class="bg-light">
                                <tr>
                                    <th scope="col" class="border-0 id-cell">ID</th>
                                    <th scope="col" class="border-0">Nazwa spółki</th>
                                    <th scope="col" class="border-0">Numer konta</th>
                                    <th scope="col" class="border-0 action-cell">Akcja</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(company, index) in companies"
                                    :key="company.id">
                                    <td class="id-cell">
                                        <dt>ID</dt>
                                        <dd>{{ company.id }}</dd>
                                    </td>
                                    <td>
                                        <dt>Nazwa spółki</dt>
                                        <dd>
                                            {{ company.name }}
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Numer konta</dt>
                                        <dd>
                                            {{ company.account_number }}
                                        </dd>
                                    </td>
                                    <td>
                                        <dt>Akcja</dt>
                                        <dd class="wsnw">
                                            <d-button
                                                @click.prevent="editCompany(company.id)"
                                                :disabled="actionInProgress">
                                                <i class="material-icons">edit</i> Edytuj
                                            </d-button>
                                            <d-button
                                                v-if="getUser.is_admin === 1"
                                                theme="danger"
                                                class="mr-1 ml-3"
                                                @click.prevent="removeCompany(company)"
                                                :disabled="actionInProgress">
                                                <i class="material-icons">delete</i> Usuń
                                            </d-button>
                                        </dd>
                                    </td>
                                </tr>
                                <tr v-if="companies.length === 0">
                                    <td colspan="4" class="text-center text-info">
                                        Brak spółek do wyświetlenia&hellip;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </d-card-body>
                    <d-card-footer>
                        <ss-pagination
                            :meta-data="paginationMetaData"
                            :initial-page="currentPage" />
                    </d-card-footer>
                </d-card>
            </transition>
        </template>
    </div>
</template>

<script>
import ListUtils from '@/utils/ListUtils.js';
import HasPagination from '@/mixins/HasPagination.vue';
import SsPagination from '@/components/common/SsPaginationNew';
import {mapGetters} from "vuex";

export default {
    name: 'CompaniesList',
    mixins: [HasPagination],
    components: {
        SsPagination
    },
    data () {
        return {
            actionInProgress: false,
            companies: [],
            loaded: false,
            loadError: false
        }
    },
    mounted (){
        this.loadItemsData();
    },
    computed: {
        ...mapGetters([
            'getUser'
        ]),
    },
    methods: {
        loadItemsData () {
            ListUtils.loadItemsData(this, {
                method: 'post',
                endpoint: '/api/companies/get-companies',
                listField: 'companies',
                pagination: true,
                params: {
                    page: this.currentPage
                }
            });
        },
        debouncedLoadFilteredData: _.debounce(function () {
            Vue.set(this, 'loaded', false);
            Vue.set(this, 'loadError', false);
            this.loadItemsData();
        }, 500),
        editCompany (id){
            this.$router.push({name: 'company-edit', params: {id: id}})
        },
        removeCompany (company) {
            this.actionInProgress = true;

            ListUtils.removeItem(this, {
                endpointBase: '/api/companies/remove-company',
                id: company.id,
                successTitle: 'Spółka została usunięta',
                successText: '',
                confirmTitle: 'Uwaga',
                confirmText: 'Czy potwierdzasz usunięcie spółki<br /><strong>' + company.name + '</strong>?',
                errorTitle: 'Wystąpił błąd',
                errorText: 'Usuwanie spółki nie powiodło się. Spróbuj ponownie.',
                successAction: () => {
                    this.actionInProgress = false;
                    this.debouncedLoadFilteredData();
                },
                failAction: () => {
                    this.actionInProgress = false;
                },
                cancelAction: () => {
                    this.actionInProgress = false;
                },
            });
        }
    }
}
</script>

<style>
    .action-cell, .id-cell{
        width: 200px;
    }
</style>
